import { Auth } from "shared/@auth/Auth";
import { useQuery } from "react-query";

export const useActiveTicketsQualifingGroup = (filters) => {
  const { makeAuthedRequest } = Auth.useContainer();

  return useQuery(
    ["activeTicketsQualifingGroup", filters],
    () => {
      const encodedGroups = filters.groups.map(encodeURIComponent).join(";");
      const encodedEvents = filters.events.map(encodeURIComponent).join(";");
      return makeAuthedRequest(
        `v1/reporting/qualifying-group-attendance/type/${filters.type}/year/${filters.year}/groupId/${encodedGroups}/eventId/${encodedEvents}`,
        { method: "GET" }
      ).then((res) => res.json());
    },
    {
      enabled: !!filters,
      staleTime: 0,
      refetchOnWindowFocus: false,
    }
  );
};
